import * as St from './EdgesHeader.styles';

import { DesignSection } from '~/core/enums';
import { useGetDesignSectionTranslations } from '~/core/hooks/useGetDesignSectionTranslations';
import { useAppDispatch } from '~/redux/hooks';
import { updateApplySameEdge } from '~/redux/slices/edge';
import DesignSectionHeader from '~organisms/DesignSectionHeader';

type EdgesHeaderProps = {
  applySameEdge: boolean;
};

const EdgesHeader = ({ applySameEdge }: EdgesHeaderProps) => {
  const dispatch = useAppDispatch();

  const { title, description, applySameEdges } =
    useGetDesignSectionTranslations(DesignSection.EDGES, ['APPLY_SAME_EDGES']);

  return (
    <DesignSectionHeader title={title} description={description}>
      <St.SameEdgeContainer>
        <St.SameEdgeText>{applySameEdges}</St.SameEdgeText>
        <St.Switch
          checked={applySameEdge}
          onChange={(checked) => dispatch(updateApplySameEdge(checked))}
        />
      </St.SameEdgeContainer>
    </DesignSectionHeader>
  );
};

export default EdgesHeader;
